export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15005.4b7c80c8.jpg";